import React, {Component} from 'react';
import './FlexRow.css';

class FlexRow extends Component {
	render() {
		return (
			<div className="FlexRow">
				{this.props.children}
			</div>
		);
	}
}

export default FlexRow;


// WEBPACK FOOTER //
// ./src/widgets/FlexRow.js